<template>
  <div class="article-trending__wrapper">
    <section-title
      :to="$options.consts.linkToTrendingCategoryPage"
      class="article-trending__title"
    >
      Trending
    </section-title>

    <article-bullet-list :articles="articles" :show-timestamp="true" />
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import SectionTitle from '../SectionTitle'
import ArticleBulletList from '../ArticleBulletList'
import { ROUTE_NAME } from 'enums/routes'
import { SPECIAL_CATEGORY } from 'enums/special-categories'

export default {
  name: 'SidebarTrending',
  components: { ArticleBulletList, SectionTitle },
  props: {
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    linkToTrendingCategoryPage: {
      name: ROUTE_NAME.CATEGORY,
      params: {
        category: SPECIAL_CATEGORY.TRENDING
      }
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>
